module.exports = ".card .desc {\n  font-size: 0.875em;\n  color: #555;\n  text-align: justify;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/special/sorcerer-magik/magik.component.less
// module id = ./src/app/special/sorcerer-magik/magik.component.less
// module chunks = main